<script setup lang="ts">
import { useWidgetStore } from '~/stores/widget-store'
const route = useRoute()
const { $get } = useApi()

const now = new Date(Date.now()).toISOString()
const widgetStore = useWidgetStore()

const { data: state } = await useAsyncData(
  `activity page data by - ${route.params.id}`,
  async () => {
    const [activity, events] = await Promise.all([
      $get(`/api/v1/activity/${route.params.id}`),
      $get(
        `/api/v1/event?scheduleInfo.saleEnding_gte=${now}&scheduleInfo.saleOpening_lte=${now}&activityId=${route.params.id}&_sort=scheduleInfo.sessionDate:asc`
      )
    ])

    return {
      activity,
      events
    }
  }
)

const { tariff } = await useOrgTariff(state.value?.activity.organization.id as string)

const { data: user } = await useAsyncData<any>(
  `get user by widgetStore.token ${widgetStore.token}`,
  () => $get('/api/v1/auth', { headers: { Authorization: widgetStore.token } }),
  { default: () => null }
)

const showPage = computed(() => {
  if (
    (tariff &&
      tariff.features.onlineSales &&
      (!user.value || (user.value && user.value.role === 'client'))) ||
    (tariff &&
      tariff.features.offlineSales &&
      user.value &&
      (user.value.role === 'merchant' || user.value.role === 'agent'))
  ) {
    return true
  }
  return false
})
</script>

<template>
  <BwWrapper v-if="showPage">
    <section v-if="state.activity && state.events && state.events.length" class="h-full w-full flex">
      <w-new-select-date-regular :activity="state?.activity" :events="state?.events" />
    </section>
  </BwWrapper>
</template>
